<template>
    <ul class="list-unstyled media-list mg-b-0">
            <li  class="media unread" v-for="card in carditems" :key="card.id" @click="trigger(card)">
                <div class="avatar"><span class="avatar-initial rounded-circle bg-indigo">{{ card.name[0] }}</span></div>
                <div class="media-body mg-l-15">
                    <div class="tx-color-03 d-flex align-items-center justify-content-between mg-b-2">
                        <span class="tx-12">Time : {{ card.date  | moment("calendar") }}</span>
                        <span class="tx-12">Batch Id: {{ card.batchid}}</span>
                    </div>
                    <h6 class="tx-13">Batch Name: {{ card.name}}</h6>
                    <div class="tx-color-03 d-flex align-items-center justify-content-between mg-b-2">
                        <span v-bind:class="{'tx-12': true, 'tx-primary': card.status === 'pushed', 'tx-danger': card.status === 'declined', 'tx-success': card.status === 'released'}">Status: {{ card.status }} </span>
                        <span class="tx-12">Total Amount: {{ card.totalamount | toCurrency }} </span>
                    </div>

                </div><!-- media-body -->
            </li>
    </ul>

</template>

<script>
    import {mapState} from "vuex"

    export default {
        props: ['carditems'],
        name: "BatchFlashCard",
        data(){
            return{
                cards: [],
                formatter: new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'NGN',
                }),

            }
        },
        methods: {

            async trigger(item){
                await this.$store.dispatch("ft/readBatchTransactions", {
                    batchref: item.batchid
                }, {root: false});
                const cards = [
                    {
                        name: 'Total Amount',
                        number: this.formatter.format(item.totalamount),
                    },
                    {
                        name: 'Total Count',
                        number: item.transcount,
                    },
                    {
                        name: 'Date Processed',
                        number: item.date.substr(0,10),
                    },
                    {
                        name: 'Number of Authorisers',
                        number: item.userauthcount + ' of ' + item.authcount,
                    }
                ];
                this.$store.commit('ft/updateBatchDetail', item);
                this.$store.commit('ft/updateBatchCard', cards);


            }

        },
        computed:{
            ...mapState([
                'ft'
            ])
        },

    }
</script>

<style scoped>

</style>
